import { electronModule } from "@/modules/electron";
import { parseDesktopRealtimeEnvelope, ParsedDesktopEvent } from "./desktop-event-parser";

export type DesktopEventListener = (event: ParsedDesktopEvent) => void;

export function subscribeDesktopRealtime(listener: DesktopEventListener): () => void {
  let unsub: (() => void) | undefined;

  const callback = ({ event }: { event: unknown }) => {
    const parsed = parseDesktopRealtimeEnvelope({ event });
    if (parsed) listener(parsed);
  };

  try {
    const maybe = electronModule.recall.onEvent?.({ callback });
    if (
      maybe &&
      typeof (maybe as Promise<unknown>) === "object" &&
      typeof (maybe as Promise<unknown>).then === "function"
    ) {
      (maybe as Promise<unknown>).then(fn => {
        if (typeof fn === "function") unsub = fn as () => void;
      });
    } else if (typeof maybe === "function") {
      unsub = maybe as () => void;
    }
  } catch (_) {
    // bridge not available
  }
  return () => {
    try {
      unsub?.();
    } catch (_) {
      /* empty */
    }
  };
}
